import { useTheme } from '@approvalmax/theme';
import { Grid, Link, Stepper, Text } from '@approvalmax/ui/src/components';
import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useMedia } from 'react-use';
import { useCompanyIdBasedOnUrl } from 'shared/hooks/useCompanyIdBasedOnUrl';
import { getPath, Path } from 'urlBuilder';

import { stepperSteps, stepperStepsToWizardStepMap } from '../../constants';
import { useActiveStepperStep } from '../../hooks/useActiveStepperStep';
import { getPadding, getTextAlign } from './KycStepper.helpers';
import { messages } from './KycStepper.messages';
import type { KycStepperProps } from './KycStepper.types';

export const KycStepper: FC<KycStepperProps> = (props) => {
    const { direction } = props;

    const { theme } = useTheme();
    const isSmallScreen = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);
    const activeStep = useActiveStepperStep();
    const { companyId } = useCompanyIdBasedOnUrl();

    return (
        <Stepper
            activeStep={activeStep}
            color='blue100'
            direction={direction || (isSmallScreen ? 'horizontal' : 'vertical')}
        >
            {stepperSteps.map((step, index) => (
                <Stepper.Step
                    key={step}
                    label={
                        <Grid
                            padding={
                                direction !== 'vertical' && isSmallScreen
                                    ? getPadding(index === 0, index === stepperSteps.length - 1)
                                    : undefined
                            }
                        >
                            {index < activeStep ? (
                                <Link
                                    font='body'
                                    fontSize='medium'
                                    fontWeight='regular'
                                    color='midnight80'
                                    textAlign={
                                        direction !== 'vertical' && isSmallScreen
                                            ? getTextAlign(index === 0, index === stepperSteps.length - 1)
                                            : undefined
                                    }
                                    as={RouterLink}
                                    to={getPath(Path.walletsKycWizard, companyId, stepperStepsToWizardStepMap[step])}
                                    data-qa={`kyc-stepper-${stepperStepsToWizardStepMap[step]}`}
                                >
                                    {messages[step]}
                                </Link>
                            ) : (
                                <Text
                                    font='body'
                                    fontSize='medium'
                                    fontWeight='regular'
                                    color='midnight80'
                                    textAlign={
                                        direction !== 'vertical' && isSmallScreen
                                            ? getTextAlign(index === 0, index === stepperSteps.length - 1)
                                            : undefined
                                    }
                                >
                                    {messages[step]}
                                </Text>
                            )}
                        </Grid>
                    }
                />
            ))}
        </Stepper>
    );
};

KycStepper.displayName = 'KycStepper';
